export const ROUTES = {
    HOMEPAGE: "/",
    ABOUTPAGE: "/aboutus",
    CONTACTPAGE: "/support",
    CUSTOMERCARE: "/customercare.html",
    // PRODUCTPAGE:"/products",
    CAREERSPAGE:"/careers",
    JOBSTORIESPAGE:"/stories", 
    JOBROLESPAGE:"/role/:id",
    JOBAPPLICATION:"/JobApplication/:id",
    // PRODUCTPORTFOLIOPAGE:"/product/:productname",
    PRODUCTPORTFOLIOPAGE: "/products/:productname",
    WARRANTYACTIVATION: "/productregistration",
    PRODUCTENQUIRY: "/productenquiry/:productname",
    PRIVACYPOLICY: "/privacy_policy",
    NOTFOUNDPAGE: "/*",
    COMINGSOON: "/comingsoon",
    SPACEDOMAINPAGE: "/space",
    RAILWAYDOMAINPAGE: "/railways",
    IOTDOMAINPAGE: "/iot",
    UHFBrochure: "brochure/UHFRadioModem.pdf",
    IN_OFES_V2Brochure: "brochure/IN_OFES_V2.pdf",
    IN_SRFX_20DBrochure: "brochure/IN_SRFX_20D.pdf",
    EmbeddedPCBrochure: "brochure/EmbeddedPC.pdf",
    FireandSafetyBrochure: "brochure/FireandSafety.pdf",
    CoachesHealthMonitoringSystemBrochure: "brochure/CoachesHealthMonitoringSystem.pdf",
    MultiProductWebAppBrochure: "brochure/MultiProductWebApp.pdf",
    KavachHealthMonitoringBrochure: "brochure/KavachHealthMonitoring.pdf",
    CentralhealthMonitoringSystemBrochure: "brochure/CentralhealthMonitoringSystem.pdf",
    IOTBrochure: "brochure/IOT.pdf",
    V3000Brochure: "brochure/V3000.pdf",
    Bothv3000andv8000withsensiconnectBrochure: "brochure/v3000_and_v8000_with_sensiconnect.pdf",
    // Bothv3000andv8000withsensiconnectBrochure: "brochure/sensiconnect.pdf",
    RugEdgeV3000Brochure: "brochure/RugEdgeV3000.pdf",
    RugEdgeR8000Brochure: "brochure/RugEdgeR8000.pdf",
    GNSSModuleBrochure: "brochure/GNSSModule.pdf",
    EdgeLinkSRF100Brochure: "brochure/EdgeLinkSRF100.pdf",
    IndustrialRuggedL2ManagedEthernetSwitchBrochure: "brochure/IndustrialRuggedL2ManagedEthernetSwitch.pdf",
    SensiConnect1612ProBrochure: "brochure/SensiConnect1612Pro.pdf",
    AxleScaleProBrochure: "brochure/AxleScalePro.pdf",
    NEWSEVENTSPAGE: "/news",
    LEADERSHIPPAGE: "/leadership",
}